import React from 'react';
import { Modal } from 'panamera-react-ui';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import css from './BookingModal.scss';
import withConfig from 'HOCs/withConfig/withConfig';
import { getUserTypeLowerCase } from 'Helpers/item';
import { USER_TYPE } from 'Constants/users';
import { customActions as customUsersActions } from 'Reducers/users';
import { operateFavouriteItem } from 'Reducers/user';
import IconWrapper from 'Components/IconWrapper/IconWrapper';
import Button from 'Components/Button/Button';
import { favouriteItemsSelector } from 'Selectors/user';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { urls as itemUrls } from 'Reducers/items';
import { post } from 'Server';
import withRouter from 'HOCs/withRouter';

const BookingModal = ({ item, loggedUser, user, onCloseBookingModal, createRelationship, sendChatMessage, router, intl, toggleLoaderState, favoriteIt, isFavorited, trackSubmitBookingRequest }) => {
    const createRelationshipBetweenSellerAndBuyer = () => {
        const data = {
            buyerId: loggedUser?.id,
            sellerId: item?.user_id,
            adId: item?.id
        };
        const dealerType = item?.user_type || getUserTypeLowerCase(user) || USER_TYPE.REGULAR;

        toggleLoaderState();

        createRelationship(data)
            .then(() => {
                toggleLoaderState();
                sendChatMessage(
                    intl.formatMessage({
                        id: 'requestEscrowDetailsMessage',
                        defaultMessage: 'Halo, Saya tertarik dengan barang yang kamu jual dan ingin melakukan booking, apakah kamu bisa mengaktifkan fiturnya?'
                    }),
                    user?.id,
                    item.id,
                    'escrowInterest'
                );
                if (!isFavorited) {
                    favoriteIt(loggedUser?.id, dealerType, (res, dispatch) => {
                        if (res.ok) {
                            dispatch(customUsersActions.operateCounter(loggedUser.id, 'favourites', 'SUM'));
                            dispatch(operateFavouriteItem(res?.data?.data?.[0], 'ADD'));
                        }
                    });
                }
                trackSubmitBookingRequest();
                router.push(`/nf/chat/new/${item.id}/${user.id}`);
            });
    };

    return (
        <Modal
            className={ css.bookingModal }
            icon=""
        >
            <div className={ css.bookingModalWrapper }>
                <div className={ css.bookingModalHeadingWrapper }>
                    <IconWrapper
                        className={ css.crossIcon }
                        icon={ 'cross' }
                        size={ 20 }
                        onClick={ onCloseBookingModal }
                        dataAutId="close-booking-modal"
                    />
                </div>
                <ImageWrapper
                    className={ css.titleImage }
                    src="https://statics.olx.co.id/olxid/escrow/booking_icon_escrow.png"
                />
                <span className={ css.bookingDetailText }>
                    {intl.formatMessage({
                        id: 'bookingDetailText',
                        defaultMessage: 'Saat ini fitur Booking belum tersedia di iklan ini. Dengan layanan Rekening Bersama di '
                    })}
                    <span className={ css.bookingDetailTextBold }>
                        {intl.formatMessage({
                            id: 'bookingDetailBold',
                            defaultMessage: 'fitur Booking'
                        })}
                    </span>
                    {intl.formatMessage({
                        id: 'bookingDetailTextMore',
                        defaultMessage: ', pengalaman jual belimu lebih aman, nyaman, dan tepercaya. Klik untuk minta Penjual aktifkan fitur Booking sekarang!'
                    })}
                </span>
                <Button
                    type="primaryBtn"
                    className={ css.bookingBtn }
                    onClick={ createRelationshipBetweenSellerAndBuyer }
                    data-aut-id="submit-booking"
                >
                    {intl.formatMessage({
                        id: 'bookingDetailButtonText',
                        defaultMessage: 'Ajukan Booking'
                    })}
                </Button>
            </div>
        </Modal>);
};

BookingModal.propTypes = {
    onCloseBookingModal: PropTypes.func,
    item: PropTypes.object,
    loggedUser: PropTypes.object,
    user: PropTypes.object,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }),
    createRelationship: PropTypes.func,
    router: PropTypes.object,
    sendChatMessage: PropTypes.func,
    toggleLoaderState: PropTypes.func,
    favoriteIt: PropTypes.func,
    isFavorited: PropTypes.bool,
    trackSubmitBookingRequest: PropTypes.func
};

BookingModal.defaultProps = {
    onCloseBookingModal: () => {},
    isFavorited: false,
    trackSubmitBookingRequest: () => {}
};

export const mapStateToProps = (state, { item }) => {
    const itemId = item?.id;

    return {
        isFavorited: favouriteItemsSelector(state, itemId)
    };
};

const mapDispatchToProps = (dispatch, { item, config }) => {
    const itemId = item?.id;
    const categoryId = item?.category_id;
    const sitecode = config?.get('siteCode');
    const headers = { 'x-panamera-sitecode': sitecode };

    return {
        createRelationship: data => dispatch(post(itemUrls.createRelationship, 'CREATE_RELATIONSHIP', {
            ...data
        }, {})),
        favoriteIt: (userId, dealerType, callback) => dispatch(post(itemUrls.favoriteIt(userId), 'ITEMS', { ads: [{ adId: itemId, categoryId, dealerType }] }, headers)).then(res => callback(res, dispatch))
    };
};

export default compose(
    injectIntl,
    withRouter,
    withConfig,
    connect(mapStateToProps, mapDispatchToProps)
)(BookingModal);
